import { submitTrialExtensionSurvey, submitMsTrialFeedback } from '../../graphql/custom-mutation'

export type SurveyVariant = 'extendTrial' | 'msTrialFeedback'

export interface ISurveyVariantConfig {
  variant: SurveyVariant
  surveyName: string
  i18nPrefix: string
  mutation: string
  // the field name on the mutation result payload
  resultKey: string
  // backend error code -> i18n message key
  errorCodeToKey: Record<string, string>
  fallbackErrorKey: string
  events: { started: string; abandoned: string; remindMeLater: string }
}

export const SURVEY_VARIANTS: Record<SurveyVariant, ISurveyVariantConfig> = {
  extendTrial: {
    variant: 'extendTrial',
    surveyName: 'extendTrial',
    i18nPrefix: 'survey.extendTrial',
    mutation: submitTrialExtensionSurvey,
    resultKey: 'submitTrialExtensionSurvey',
    errorCodeToKey: {
      NOT_ELIGIBLE: 'survey.extendTrial.error.notEligible',
      ALREADY_EXTENDED: 'survey.extendTrial.error.alreadyExtended',
      VALIDATION_FAILED: 'survey.extendTrial.error.validationFailed',
    },
    fallbackErrorKey: 'survey.extendTrial.error.submitFailed',
    events: {
      started: 'TRIAL_EXTENSION_SURVEY_STARTED',
      abandoned: 'TRIAL_EXTENSION_SURVEY_ABANDONED',
      remindMeLater: 'TRIAL_EXTENSION_REMIND_ME_LATER_CLICKED',
    },
  },
  msTrialFeedback: {
    variant: 'msTrialFeedback',
    surveyName: 'msTrialFeedback',
    i18nPrefix: 'survey.msTrialFeedback',
    mutation: submitMsTrialFeedback,
    resultKey: 'submitMsTrialFeedback',
    errorCodeToKey: {
      NOT_ELIGIBLE: 'survey.msTrialFeedback.error.notEligible',
      ALREADY_SUBMITTED: 'survey.msTrialFeedback.error.alreadySubmitted',
      VALIDATION_FAILED: 'survey.msTrialFeedback.error.validationFailed',
    },
    fallbackErrorKey: 'survey.msTrialFeedback.error.submitFailed',
    events: {
      started: 'MS_TRIAL_FEEDBACK_SURVEY_STARTED',
      abandoned: 'MS_TRIAL_FEEDBACK_SURVEY_ABANDONED',
      remindMeLater: 'MS_TRIAL_FEEDBACK_REMIND_ME_LATER_CLICKED',
    },
  },
}
